import { preview } from '@/components/form/preview'
import { useOrderViolationTexts } from '@/intl'
import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function RequiredTags(props: Props) {
  const { extOrder } = props
  const { getViolationText } = useOrderViolationTexts()
  const texts = useTexts()
  const hasViolations = extOrder.isUnassigned ? false : extOrder.violations?.includes('TGI')
  const tagsCount = extOrder.orderStep.tagsIn.length

  return (
    <preview.Field label={texts.requiredTags.label(tagsCount)} variant="alternative">
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('TGI')} /> : null
        }
      >
        <preview.TagsList tags={extOrder.orderStep.tagsIn} maxHeightPx={48} />
      </preview.ViolationContainer>
    </preview.Field>
  )
}
